import React from "react";
import style from "./LeadershipUpdated.module.css";
import { Deepa, Sachin, DeepaUpdatedImage, SachinUpdatedImage, founderImg } from '../../assets';
import { aboutUsOrnament } from "../../assets";

export default function LeadershipUpdated() {

    return(
        <div style={{backgroundColor: "white", padding: "0 2rem"}}>
            <div className={style.main_container}>
                
                <h1>Our Founder’s Message</h1>
                
                <div className={style.Deepa_container}  data-aos="fade-right" data-aos-duration="1000" data-aos-offset="100">
                    <div className={style.image_container}>
                        <img className={`${style.aboutUsOrnament1} ${style.aboutUsOrnament}`} src={aboutUsOrnament} alt="aboutUsOrnament" />
                        <img className={`${style.aboutUsOrnament2} ${style.aboutUsOrnament}`} src={aboutUsOrnament} alt="aboutUsOrnament" />
                        <img style={{width: "100%", height: "100%", objectFit: "cover", objectPosition: "top", borderRadius: "10px"}} src={DeepaUpdatedImage} alt="Founder Image - 1" />
                        {/* <img className={`${style.aboutUsOrnament2} ${style.aboutUsOrnament}`} src={aboutUsOrnament} alt="aboutUsOrnament" /> */}
                    </div>
                    <div className={style.content_container}>
                        <p>
                            We believe in the power of technology to reshape industries and redefine success. With a strong foundation in technology-driven staffing solutions, we are committed to bridging talent with opportunity through innovation, AI-powered processes, and client-centric strategies. My vision is to create a future-ready workforce where businesses can thrive with the right talent at the right time. Together, we are not just staffing, we are engineering success stories for businesses and professionals alike.
                        </p>
                        <p style={{fontWeight: "700"}}>
                            Deepa Seth <br/>
                            <span style={{fontWeight: "300"}}>Co-Founder & Director, Client Solutions</span>
                        </p>
                    </div>
                </div>
                
                <div className={style.Sachin_container} data-aos="fade-left" data-aos-duration="1000" data-aos-offset="100">
                    <div className={style.content_container}>
                        <p>
                            Innovation, agility, and sustainable growth are the pillars of NuFolks. As we navigate the evolving landscape of recruitment and workforce solutions, we are driven by the mission to integrate technology with human potential. My focus is on continuous improvement, data-driven hiring strategies, and fostering a culture of collaboration that fuels long-term success. At NuFolks, we don’t just fill positions; we create impactful career pathways and build future-proof staffing solutions that empower businesses and professionals alike.
                        </p>
                        <p style={{ fontWeight: "700"}}>
                            Sachin Prakash <br/>
                            <span style={{fontWeight: "300"}}>Co-Founder & Business Head</span>
                        </p>
                    </div>
                    <div className={style.image_container}>
                        <img className={`${style.aboutUsOrnament3} ${style.aboutUsOrnament}`} src={aboutUsOrnament} alt="aboutUsOrnament" />
                        <img className={`${style.aboutUsOrnament4} ${style.aboutUsOrnament}`} src={aboutUsOrnament} alt="aboutUsOrnament" />
                        <img style={{width: "100%", height: "100%", objectFit: "cover", objectPosition: "top", borderRadius: "10px"}} src={SachinUpdatedImage} alt="Founder Image - 2" />
                    </div>
                </div>

            </div>
        </div>
    )
}